export default __webpack_public_path__ + "assets/images/e376e12ff1373aa2c57f8b9d92131903.png";